import { render, staticRenderFns } from "./SDropdown.vue?vue&type=template&id=62fa8afa&scoped=true&"
import script from "./SDropdown.vue?vue&type=script&lang=ts&"
export * from "./SDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./SDropdown.vue?vue&type=style&index=0&id=62fa8afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fa8afa",
  null
  
)

export default component.exports